module.exports = __webpack_public_path__ + "static/img/1055_big.73cb624.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1055_big.png
// module id = eFUY
// module chunks = 1